import script from "./VisitorSurvey.vue?vue&type=script&setup=true&lang=ts"
export * from "./VisitorSurvey.vue?vue&type=script&setup=true&lang=ts"

import "./VisitorSurvey.vue?vue&type=style&index=0&id=5f75b628&scoped=true&lang=scss"

import exportComponent from "/opt/tiger/compile_path/src/code.byted.org/ad/se_tt4b_academy_advertiser_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f75b628"]])

export default __exports__